import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../setup/auth/authService';

const PrivateRoutes = () => {
  const { user } = useAuth();

  return (user && !user.expired)  ? <Outlet /> : <Navigate to="/logout" replace />;
};

export default PrivateRoutes;
